export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";

export const USER_ADD = "USER_ADD";
export const USER_UPDATE = "USER_UPDATE";
export const TEMPLATE_ADD = "TEMPLATE_ADD";
export const TEMPLATE_UPDATE = "TEMPLATE_UPDATE";
export const CMS_ADD = "CMS_ADD";
export const CMS_UPDATE = "CMS_UPDATE";
export const FORGOT = "FORGOT";
export const PROFILE_UPDATE = "PROFILE_UPDATE";
export const PASSWORD_UPDATE = "PASSWORD_UPDATE";
export const SETTINGS_UPDATE = "SETTINGS_UPDATE";
export const FAQ_ADD = "FAQ_ADD";
export const FAQ_UPDATE = "FAQ_UPDATE";
export const PERPETUAL_ADD = "PERPETUAL_ADD";
export const PERPETUAL_UPDATE = "PERPETUAL_UPDATE";
export const REPLY_CONTACT = "REPLY_CONTACT";
export const SUPPORT_REPLY = "SUPPORT_REPLY";
export const CURRENCY_ADD = "CURRENCY_ADD";
export const CURRENCY_UPDATE = "CURRENCY_UPDATE";
export const Lauchpad_ADD = "Lauchpad_ADD";
export const STAKING_ADD = "STAKING_ADD";
export const STAKING_UPDATE = "STAKING_UPDATE";
export const CONTACT_ADD = "CONTACT_ADD";
export const Lauchpad_UPDATE="Lauchpad_UPDATE";
export const UPDATE_LAUNCHPAD="UPDATE_LAUNCHPAD"


